<template>
  <div class="pay">
    <!-- <van-nav-bar :title="lang.payTitle" :left-arrow="!$route.query.fromapp" @click-left="back" /> -->
    <van-nav-bar :title="lang.payTitle" :left-arrow="!isApp">
      <template #left>
        <van-icon name="arrow-left" @click="back" />
        <van-icon name="cross" @click="goHome" style="margin-left: 10px" />
      </template>
    </van-nav-bar>
    <section class="pay-box">
      <!-- <van-tabs v-model="active" :line-width="173" color="#292630">
        <van-tab :title="lang.paypal" :disabled="active == 1"> -->
      <div v-if="active == 0" style="height: 190px">
        <p class="pay-title">{{ lang.orderInfo }}</p>
        <div class="order-info">
          <van-cell-group>
            <!-- 0903 源代码中下面那行是注释掉的 -->
            <!-- <van-cell :title="`${order.item}`" :value="`HK $${order.money}`" :label="`${lang.coinNum}${order.propertyCoin}`" /> -->
            <van-cell :title="`${order.itemWithCulture}`" :value="`HK $${order.money}`" />
          </van-cell-group>
          <van-panel :title="lang.sum" :status="`HK $${order.money}`"></van-panel>
        </div>
      </div>
      <!-- </van-tab> -->
      <!-- <van-tab :title="lang.trans" :disabled="active == 0"> -->
      <div v-if="active == 1">
        <div class="trans-title">
          <div class="OneSection">
            <p class="blod">{{ lang.section1 }}</p>
            <br />
            <span :class="['title', url ? '' : 'width']">{{ lang.t4 }}<i v-if="url"></i> </span>：{{ orderid }} <br />
            <span :class="['title', url ? '' : 'width']">{{ lang.t7 }}<i v-if="url"></i> </span>：{{ order.itemWithCulture }} <br />
            <span :class="['title', url ? '' : 'width']">{{ lang.t6 }}<i v-if="url"></i> </span> ：HK${{ order.money }} <br />
            <span :class="['title', url ? '' : 'width']">{{ lang.t1 }}<i v-if="url"></i> </span>：HOUSE730 LIMITED <br />
            <!-- 中銀香港 -->
            <span :class="['title', url ? '' : 'width']">{{ lang.t2 }}<i v-if="url"></i> </span>：875-2-035677-8 <br />
            <!-- 恒生銀行 -->
            <span :class="['title', url ? '' : 'width']">{{ lang.t3 }}<i v-if="url"></i> </span>：752-007526-883 <br />
            <span :class="['title', url ? '' : 'width']">{{ lang.t333 }}<i v-if="url"></i> </span>：023-786478-838 <br />
            <span :class="['title', url ? '' : 'width']">{{ lang.t33 }}<i v-if="url"></i> </span>：3575503 <br />
          </div>
          <div class="OneSection">
            <p class="blod">{{ lang.section2 }}</p>
            <br />
            (1)<span class="title">{{ lang.t21 }}<i v-if="url"></i></span>：+852-3619-3201 <br />
            (2)<span class="title">{{ lang.t22 }}<i v-if="url"></i></span>：+852-9135-0718 <br />
            (3)<span class="title">{{ lang.t23 }}<i v-if="url"></i></span>： support@house730.com,{{ lang.checked }}
          </div>
          <div class="OneSection">
            <p class="blod">{{ lang.section3 }}</p>
            <br />
            Whatsapp：+852-5726-6308<br />
            Email：support@house730.com <br />
            Tel：+852-3619-3200<br />
          </div>
        </div>
      </div>
      <div v-if="active == 2">
        <div class="paydolBox" style="height: 190px">
          <div class="paydoltit">{{ lang.orderInfo }}</div>
          <div class="pdollflex">
            <span>{{ lang.pdmeth }}</span>
            <span class="pdgray">{{ lang.cred }} (VISA, Mastercard)</span>
          </div>
          <div class="pdollflex">
            <span>{{ `${order.itemWithCulture}` }}</span>
            <span class="pdgray">{{ `HK $${order.money}` }}</span>
          </div>
          <div class="pdollflex" style="border-bottom: none">
            <span>{{ lang.sum }}</span>
            <span class="pdred">{{ `HK $${order.money}` }}</span>
          </div>
          <form name="payForm" method="post" ref="form" :action="urlPd"></form>
          <button class="pdbtn" @click="submitCre">
            <img src="../assets/creditcard.png" style="vertical-align: middle; display: inline-block; width: 22px; height: 22px" alt="##" />&nbsp;{{ lang.cred }}
          </button>
          <div>
            <p style="display: inline-block; font-size: 12px; color: #7a8387">{{ lang.tsp }}</p>
            <img src="../assets/paydollar.png" alt="##" style="vertical-align: middle; display: inline-block; width: 36px; height: 22px" />
          </div>
        </div>
      </div>
      <div v-if="active == 3">
        <div class="paydolBox" style="height: 190px">
          <div class="paydoltit">{{ lang.orderInfo }}</div>
          <div class="pdollflex">
            <span>{{ lang.pdmeth }}</span>
            <span class="pdgray">Alipay HK</span>
          </div>
          <div class="pdollflex">
            <span>{{ `${order.itemWithCulture}` }}</span>
            <span class="pdgray">{{ `HK $${order.money}` }}</span>
          </div>
          <div class="pdollflex" style="border-bottom: none">
            <span>{{ lang.sum }}</span>
            <span class="pdred" style="color: #ed1c24">{{ `HK $${order.money}` }}</span>
          </div>
          <div style="padding-right: 16px">
            <div class="alipay-ttps">{{ lang.alipayTips }}</div>
            <!-- <form name="payForm" method="post" ref="form" :action="urlPd"></form> -->
            <div class="wepdbtn" @click="submitCre">
              <img src="../assets/ali-pay@2x.png" style="vertical-align: middle; display: inline-block; width: 20px; margin-right: 10px; height: 20px" alt="##" />
              <img src="../assets/alipayText.png" alt="" style="width: 70px; height: 16px" />
            </div>
            <div>
              <p style="display: inline-block; font-size: 12px; color: #7a8387">{{ lang.tsp }}</p>
              <img src="../assets/paydollar.png" alt="##" style="vertical-align: middle; display: inline-block; width: 36px; height: 22px" />
            </div>
          </div>
          <div v-html="alipayForm"></div>
        </div>
      </div>
      <div v-if="active == 4">
        <div class="paydolBox" style="height: 190px">
          <div class="paydoltit">{{ lang.orderInfo }}</div>
          <div class="pdollflex">
            <span>{{ lang.pdmeth }}</span>
            <span class="pdgray">WeChat Pay HK</span>
          </div>
          <div class="pdollflex">
            <span>{{ `${order.itemWithCulture}` }}</span>
            <span class="pdgray">{{ `HK $${order.money}` }}</span>
          </div>
          <div class="pdollflex" style="border-bottom: none">
            <span>{{ lang.sum }}</span>
            <span class="pdred" style="color: #ed1c24">{{ `HK $${order.money}` }}</span>
          </div>
          <div style="padding-right: 16px">
            <div class="alipay-ttps" style="line-height: 16px; margin-bottom: 8px">{{ lang.wepayTips1 }}</div>
            <div class="alipay-ttps">{{ lang.wepayTips2[0] }} <span style="color: #0054a6; font-weight: bold">30</span> {{ lang.wepayTips2[1] }}</div>
            <form name="payForm" method="post" ref="form" :action="urlPd"></form>
            <div class="wepdbtn" style="background: #09bb07" @click="submitCre">
              <img src="../assets/wechatBtn.png" style="vertical-align: middle; display: inline-block; width: 22px; margin-right: 10px; height: 22px" alt="##" />
              <span style="font-weight: 400; font-size: 16px">WeChat Pay HK</span>
            </div>
            <div>
              <p style="display: inline-block; font-size: 12px; color: #7a8387">{{ lang.tsp }}</p>
              <img src="../assets/paydollar.png" alt="##" style="vertical-align: middle; display: inline-block; width: 36px; height: 22px" />
            </div>
          </div>
          <div v-html="alipayForm"></div>
        </div>
      </div>
      <!-- </van-tab>
      </van-tabs> -->

      <!-- liulei 0903 修改 下一行代码注释需放开 -->
      <div class="pay-paypal" v-show="active == 0"></div>
      <!-- <div id="paypal-button-container">我是无用代码</div> -->
    </section>
    <div class="pay-loading-box" v-if="showLoading">
      <div class="pay-loading">
        <van-loading size="50" text-size="15px" vertical></van-loading>
        <label>{{ lang.loading }}</label>
      </div>
    </div>
    <van-dialog class="exTipClass" v-model="exTip" :lazy-render="false" :confirmButtonText="lang.exConfirm" @confirm="$router.go(-1)">
      <van-icon name="cross" @click="exTip = false" />
      <!--  lang.exTip | -->
      <p>{{ lang.exTip | exTime(order.expireTime, order.orderStatus) }}</p>
      <div class="expay"></div>
    </van-dialog>
    <van-dialog class="exTipClass" v-model="dolTip" :lazy-render="false" :confirmButtonText="lang.exConfirm" @confirm="submitCre">
      <van-icon name="cross" @click="dolTip = false" />
      <p>{{ lang.exTip | exTime(order.expireTime, order.orderStatus) }}</p>
    </van-dialog>
    <!-- <van-dialog
      class="exTipClass"
      v-model="cancelTip"
      :lazy-render="false"
      show-cancel-button
      :cancelButtonText="lang.cancelBtn"
      :confirmButtonText="lang.exConfirm"
      @cancel="goBackPage"
      @confirm="submitCre"
    >
      <van-icon name="cross" @click="cancelTip = false" />
      <p>{{ lang.exTip | exTime(order.expireTime, order.orderStatus) }}</p>
    </van-dialog> -->
  </div>
</template>

<script>
import { CellGroup, Cell, NavBar, Panel, Tab, Tabs, Dialog, Loading, Icon } from 'vant';
import lang from './../../common/language/orders';
import 'vant/lib/button/style';

export default {
  name: 'pay',
  data() {
    return {
      isApp: false,
      isDisable: true,
      alipayForm: '',
      // cancelTip: false,
      dolTip: false,
      url: !document.URL.indexOf('en-us') > -1,
      lang: lang,
      active: 0,
      type: 'paypal',
      orderid: '',
      order: {},
      showLoading: false,
      form: '',
      app: '',
      version: '',
      exTip: false,
      paytype: '',
      urlPd: '',
      paysource: 'coin',
      paymentType: 4,
      backFlag: 0,
    };
  },
  // 格式化过期时间
  filters: {
    exTime(orderStatus, time) {
      if (orderStatus == 2) return;
      // 1.获取当前时间
      let nowDate = Math.round(new Date().getTime() / 1000);
      // 未过期订单
      if (time > nowDate) {
        let hours = (time - nowDate) / 60 / 60 / 24;
        let intHour = parseInt(hours);
        // 规则：不足一天展示一天,1.2天 展示2天
        if (hours > intHour) {
          intHour += 1;
        }
        return lang.exTip.replace(/7/, intHour);
      }
    },
  },
  components: {
    [Cell.name]: Cell,
    [NavBar.name]: NavBar,
    [Panel.name]: Panel,
    [Panel.Tab]: Tab,
    [Tabs.name]: Tabs,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
  },
  created() {
    this.clearCookie();
    this.version = this.$route.query.version ? `&version=${this.$route.query.version}` : '';
    this.app = this.$route.query.fromapp ? `&fromapp=${this.$route.query.fromapp}` : '';
    this.isApp = navigator.userAgent.indexOf('house730') > -1 ? true : false;
    this.type = this.$route.query.type || 'paypal';
    // if (this.type == 'lpay' || this.type == 'wpay') {
    //   this.orderid = this.$route.query.orderid || this.$route.query.orderId;
    // } else {
    //   this.orderid = this.$route.query.orderid || this.$route.query.Ref;
    // }
    this.orderid = this.$route.query.orderid || this.$route.query.orderId;
    this.form = this.$route.query.form == 'post';
    this.paytype = this.$route.query.paytype || '';

    if (this.type == 'transfer') {
      this.active = 1;
      this.emil();
      //  获取银行转账支付指南邮件
    }
    if ((this.type == 'paydollar' && !this.$route.query.paymentType) || this.$route.query.paymentType == 4) {
      this.active = 2;
      this.paymentType = 4;
    }
    if ((this.type == 'lpay' && !this.$route.query.paymentType) || this.$route.query.paymentType == 5) {
      this.active = 3;
      this.paymentType = 5;
    }
    if ((this.type == 'wpay' && !this.$route.query.paymentType) || this.$route.query.paymentType == 6) {
      this.active = 4;
      this.paymentType = 6;
    }
  },
  beforeRouteLeave(to, from, next) {
    document.querySelector('body').style.height = '100%';
    document.querySelector('body').style.overflow = 'initial';
    document.querySelector('.pay-paypal').style.height = 'initial';
    document.querySelector('.pay-paypal').style.overflow = 'initial';
    next();
  },
  mounted() {
    if (!this.orderid && this.type == 'paypal') {
      this.showInfo(this.lang.notOrder);
    } else {
      if (this.orderid && this.type == 'paypal' && navigator.language.indexOf('en') == -1) {
        // document.querySelector("body").style.height = "480px";
        // document.querySelector("body").style.overflow = "hidden";
        // document.querySelector(".pay-paypal").style.height = "200px";
        // document.querySelector(".pay-paypal").style.overflow = "hidden";
      }

      //判断paypal SDK是否已加载
      typeof paypal === 'undefined' ? this.loadPaypal() : (this.initPay('.pay-paypal'), this.initPay('.expay'));
      this.axios.get(this.pub.getApi().GetOrderRecord, { params: { orderId: this.orderid } }).then((res) => {
        if (this.type == 'paydollar' || this.type == 'lpay' || this.type == 'wpay') {
          if (res.data.result) {
            this.isDisable = false;
            this.order = res.data.result;
          } else {
            this.isDisable = false;
            this.showInfo(this.lang.dealCancel);
            return;
          } //"交易失敗，請聯繫管理員"
          // 成功 失败 取消
          if (this.paytype == 'cancel') {
            this.dolTip = true;
          }
          if (this.paytype == 'success') {
            this.showInfo(this.lang.success);
          }
          if (this.paytype == 'fail') {
            this.showInfo(this.lang.dealCancel);
            // this.$dialog.alert({ title: this.lang.tip, message: this.lang.dealCancel, confirmButtonText: this.lang.confirm });
          }
        } else {
          if (res.data.result) {
            this.order = res.data.result;
            this.order.orderStatus === 1 ? this.showInfo(this.lang.orderPaid) : ''; //此订单已经付款
          } else {
            this.showInfo(this.lang.dealCancel);
          } //"交易失敗，請聯繫管理員"
        }
      });
    }
  },
  methods: {
    //清空cookie
    clearCookie() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--; ) {
          document.cookie = keys[i] + '=0;path=/;domain=alipay.com;expires=' + new Date(0).toUTCString(); //清除一级域名下的或指定的，例如 .kevis.com
          document.cookie = keys[i] + '=0;path=/;domain=alipay.hk;expires=' + new Date(0).toUTCString();
          document.cookie = keys[i] + '=0;path=/;domain=alipaydev.com;expires=' + new Date(0).toUTCString(); //清除一级域名下的或指定的，例如 .kevis.com
        }
      }
      console.log('已清除');
    },
    async submitCre() {
      if (!this.isDisable) {
        this.paysource = this.$route.query.source;
        let _this = this;
        if (this.active === 3 || this.active === 4) {
          // CreatePayDollarOrderCLientPay
          await _this.axios
            .post(_this.pub.getApi().CreatePayDollarOrderCLientPay, {
              paymentType: this.paymentType,
              orderID: _this.orderid,
              platformType: 'wap',
              source: this.paysource,
            })
            .then((res) => {
              _this.isDisable = true;
              setTimeout(() => {
                _this.isDisable = false;
              }, 3000);
              if (res.data.code == 0) {
                this.alipayForm = res.data.result;
                setTimeout(() => {
                  console.log(document.getElementById('submit'));
                  document.getElementById('submit').click();
                }, 500);
              } else {
                _this.showInfo(this.lang.status);
                return;
              }
            });
        } else {
          await _this.axios
            .post(_this.pub.getApi().CreatePayDollarOrder, {
              paymentType: this.paymentType,
              orderID: _this.orderid,
              platformType: 'wap',
              source: this.paysource,
            })
            .then((res) => {
              _this.isDisable = true;
              setTimeout(() => {
                _this.isDisable = false;
              }, 3000);
              if (res.data.code == 0) {
                this.paycode = res.data.code;
                _this.urlPd = res.data.result;
              } else {
                _this.showInfo(this.lang.status);
                return;
              }
            });
          if (this.paycode == 0) {
            _this.$refs.form.submit();
          }
          // _this.$refs.form.submit();
          // window.open( _this.urlPd,'_blank')
        }
      }
    },
    //加载paypal
    loadPaypal() {
      let payScript = document.createElement('script');
      payScript.type = 'text/javascript';
      payScript.src = document.URL.indexOf('en-us') > -1 ? this.pub.config.paypalSdkEN : document.URL.indexOf('zh-cn') > -1 ? this.pub.config.paypalSdkCN : this.pub.config.paypalSdk;
      document.body.appendChild(payScript);
      payScript.onload = () => {
        this.initPay('.pay-paypal');
        this.initPay('.expay');
      };
    },
    //初始化支付
    initPay(dom) {
      // console.log('init')
      let _this = this;
      paypal
        .Buttons({
          style: {
            color: 'blue',
            shape: 'rect',
            label: 'paypal',
          },
          //创建支付订单
          createOrder: function () {
            _this.exTip = false;
            return _this.axios
              .post(_this.pub.getApi().CreatePaypalOrder, {
                orderID: _this.orderid,
              })
              .then((res) => {
                if (res.data.code === 0) return res.data.result;
                else _this.showInfo(_this.lang.status);
              });
          },
          //订单支付回调 成功 || 失败
          onApprove: function (a, n) {
            _this.showLoading = true;
            return _this.axios
              .post(_this.pub.getApi().CapturePaypalOrder, {
                orderID: _this.orderid,
                paypalOrderID: a.orderID,
              })
              .then((res) => {
                _this.showLoading = false;
                res.data.code === 0 ? _this.showInfo(_this.lang.success) : _this.showInfo(`${_this.lang.fail}${res.data.message}`);
              });
            setTimeout(() => (_this.showLoading = false), 20000);
          },
          //用户取消操作回调 交易取消
          onCancel: function (a) {
            // if (_this.$route.query.source == 'coin') {
            //   Dialog.alert({ title: _this.lang.tip, message: _this.lang.cancel, confirmButtonText: _this.lang.confirm }).then(() => {});
            // } else {
            _this.exTip = true;
            // }
          },
          //交易异常回调 交易失敗，請聯繫管理員
          onError: function (a, n) {
            // console.log(a, n)
            _this.$dialog.alert({ title: _this.lang.tip, message: _this.lang.dealCancel, confirmButtonText: _this.lang.confirm });
          },
        })
        .render(dom);
    },
    back() {
      // this.$router.push(`/my-properties${this.app}${this.version}`);
      // this.backFlag = 1;
      // this.cancelTip = true;
      this.$router.push(`/orders?${this.app}${this.version}`);

      // window.history.go(-1);

      // let path = this.$store.state.path;
      // let query = this.$store.state.path.split('?')[1];
      // if (path.indexOf('type=1') > -1 || path.indexOf('type=2') > -1 || this.$route.query.source == 'coin') {
      //   this.order.orderStatus === 1 ? sessionStorage.setItem('flag', true) : sessionStorage.setItem('flag', false);
      // } else {
      // }
    },
    // goBackPage() {
    //   if (this.backFlag === 1) {
    //     this.$router.push(`/orders${this.app}${this.version}`);
    //   }
    //   if (this.backFlag === 2) {
    //     this.$router.push(`/${this.app}${this.version}`);
    //   }
    // },
    goHome() {
      // this.backFlag = 2;
      // this.cancelTip = true;
      this.$router.push(`/?${this.app}${this.version}`);
    },
    // 发送邮件
    emil() {
      this.axios.get(this.pub.getApi().GetBankTransferPaymentOrderHelp, { params: { orderId: this.orderid } });
    },
    showInfo(text) {
      Dialog.alert({
        title: this.lang.tip,
        message: text,
        confirmButtonText: this.lang.confirm,
      }).then(() => {
        this.order.orderStatus === 1 ? sessionStorage.setItem('flag', true) : sessionStorage.setItem('flag', false);
        if (this.$route.query.source == 'coin') {
          // 如果是通过充值屋币进入页面
          if (this.form) {
            if (this.$route.query.type == 'paydollar') {
              this.$router.push({ path: '/storedValueMoney', query: { page: 1, from: 'post', paytype: 'success' } });
            } else {
              this.$router.push({ path: '/storedValueMoney', query: { page: 1, from: 'post' } });
            }
          } else {
            if (this.$route.query.type == 'paydollar') {
              this.$router.push({ path: '/storedValueMoney', query: { page: 1, paytype: 'success' } });
            } else {
              this.$router.push({ path: '/storedValueMoney', query: { page: 1 } });
            }
          }
        }
        if (this.$route.query.source == 'orders') {
          this.$router.push({ path: '/orders' });
        }
        if (this.$route.query.source == 'post' && this.$route.query.type !== 'paydollar') {
          // 如果是通过刊登楼盘进入页面
          // this.$router.push({ path: this.$store.state.path, query: { success: 1 } });
          this.$router.push(`/my-properties${this.app}${this.version}`);
        } else if (this.$route.query.type == 'paydollar' && this.$route.query.source == 'post') {
          this.$router.push(`/my-properties${this.app}${this.version}`);
        }
      });
    },
  },
  metaInfo() {
    return {
      title: this.lang.payTitle,
    };
  },
};
</script>

<style lang="scss" scoped>
.exTipClass {
  .expay {
    position: absolute;
    right: 0;
    width: 100%;
    height: 40px;
    overflow: hidden;
    bottom: 0;
    opacity: 0.01;
    z-index: 999;
  }
  .van-icon {
    position: absolute;
    right: 10px;
    top: 8px;
  }
  p {
    margin: 25px 0;
    padding: 10px;
    font-size: 14px;
  }
}
.paydolBox {
  height: 354px;
  padding-left: 16px;
  background-color: #fff;
  margin-top: 16px;
  .paydoltit {
    text-align: left;
    font-size: 16px;
    color: #333333;
    line-height: 54px;
    height: 54px;
    border-bottom: 1px solid #dcdcdc;
    font-weight: 700;
  }
  .pdollflex {
    padding-right: 16px;
    border-bottom: 1px solid #dcdcdc;
    height: 44px;
    line-height: 44px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 14px;
    .pdgray {
      color: #999999;
    }
    .pdred {
      color: #ed1818;
    }
  }
  .pdbtn {
    width: 98%;
    height: 44px;
    font-size: 16px;
    color: #ffffff;
    border-radius: 5px;
    background-color: #0070ba;
    border: 0 solid transparent;
    margin: 16px 16px 13px 0;
  }
}
.trans-title {
  font-size: 12px;
  color: #333333;
  letter-spacing: 0.14px;
  line-height: 18px;
  text-align: left;
  .OneSection {
    background: #fff;
    margin-top: 17px;
    padding: 8px 17px;
    width: 100%;
    box-sizing: border-box;
    .width {
      width: 55px;
    }
    .title {
      height: 20px;
      text-align: justify;
      display: inline-block;
      vertical-align: top;
      i {
        display: inline-block;
        width: 100%;
      }
    }
    .bold {
      font-weight: 600;
    }
  }
}
.pay {
  height: 100vh;
  // overflow: hidden;
  background: #f5f6f7;
}
.pay-box {
  min-height: 150px;

  .van-panel__content {
    padding: 20px;
  }

  .van-cell__title {
    text-align: left;
  }

  .pay-title {
    display: block;
    padding: 20px;
    text-align: left;
    font-size: 16px;
    background: white;
    font-weight: 600;
    margin-top: 20px;
  }
  .pay-paypal {
    width: 100%;
    text-align: center;
    margin: auto;
    // background: white;
    padding: 10px 20px 50px 20px;
    box-sizing: border-box;
  }
}
.pay-loading-box {
  background-color: rgba(40, 44, 52, 0.7);
  width: 100%;
  height: 100vh;
  z-index: 999;
  position: fixed;
  top: 0px;
  left: 0px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .van-loading {
    width: 100% !important;
    margin-bottom: 20px;
  }
}
.wepdbtn {
  // padding: 0 20px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  background: #00a0e9;
  // background-image: url(../assets/pay_bg@2x.png);
  // background-size: 95% 100%;
  // background-repeat: no-repeat;
  border-radius: 4px;
  overflow: hidden;
  background-position: center;
  margin-bottom: 12px;
}
.alipay-ttps {
  text-align: left;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #ed1c24;
  margin-top: 12px;
  margin-bottom: 24px;
}
</style>
